export default __webpack_public_path__ + "static/media/mail.2c9f6f48.svg";